module.exports = ""


//////////////////
// WEBPACK FOOTER
// /Users/cmedina/Code/motto_frontend/src/app/auth/logout/logout.component.html
// module id = ../../../../../src/app/auth/logout/logout.component.html
// module chunks = main